// CART PRODUCTS IDS
export const FIBER_200 = "d03c8fa0-4464-4ee7-a979-0700e2f5d290";
export const FIBER_500 = "c75fb0df-6d48-4a06-bb10-3ee47a8d3d28";
export const FIBER_GIG = "2b09989e-1696-4cc2-b13c-7e0950b74588";
export const FIBER_2GIG = "67e4d13f-65f8-485b-8ebc-9c922e72c1a2";
export const FIBER_5GIG = "4a7c0a86-9b8d-4b5f-b60f-10849155f5c0";
export const FIBER_7GIG = "4fbc7f33-616d-4923-bbb7-e88e46658917";

// VAS
export const WIFI_SECURITY = "1e9899f8-ba18-4751-bc1d-e83d1b813507";
export const WHOLE_HOME_WIFI = "06cbe317-ccfd-461c-9504-df01e8a522da";
export const MY_PREMIUM_TECH_PRO = "cf09e987-e30a-4c0b-ae68-bfc4344769da";
export const HOMESHIELD_ELITE = "24b9d45c-25ec-49fa-b896-ffa354ccbb82";
export const YTTV_BASIC = "3bdcc2d3-d9e5-4c7d-9ede-1e1e77aec404";
export const UNLIMITED_VOICE = "ac0cc409-17d5-48ab-b12b-d5b6ce2322a3";
export const TOTAL_SHIELD = "2849c67b-4a32-4ca1-aebc-cf4b61d0e27e";
export const IDENTITY_PROTECTION = "792a5ad9-b779-4a6c-98bf-2eef56545a6b";
export const WIFI_SECURITY_PLUS = "9b8987b6-1c33-4af3-a0ce-5c3f642ad364";
export const UNBREAKABLE_WIFI = "5ea7fffd-efaa-4878-a5b7-a36419d536aa";
export const NETFLIX_BUNDLE = "66027766-735a-4e06-951e-234bacff458f";

export const productHashMap = {
  fiber200: FIBER_200,
  fiber500: FIBER_500,
  fiberGig: FIBER_GIG,
  fiber2Gig: FIBER_2GIG,
  fiber5Gig: FIBER_5GIG,
  fiber7Gig: FIBER_7GIG,
  wifiSecurity: WIFI_SECURITY,
  wholeHomeWifi: WHOLE_HOME_WIFI,
  myPremiumTechPro: MY_PREMIUM_TECH_PRO,
  homeshieldElite: HOMESHIELD_ELITE,
  yttvBasic: YTTV_BASIC,
  unlimitedVoice: UNLIMITED_VOICE,
  totalShield: TOTAL_SHIELD,
  identityProtection: IDENTITY_PROTECTION,
  wifiSecurityPlus: WIFI_SECURITY_PLUS,
  unbreakableWifi: UNBREAKABLE_WIFI,
  netflixBundle: NETFLIX_BUNDLE,
};

export const productKeyMap = {
  "fiber-200m": "fiber200",
  "fiber-500m": "fiber500",
  "fiber-gig": "fiberGig",
  "fiber-2-gig": "fiber2Gig",
  "fiber-5-gig": "fiber5Gig",
  "fiber-7-gig": "fiber7Gig",
  "wifi-security": "wifiSecurity",
  "whole-home-wifi": "wholeHomeWifi",
  "my-premium-tech-pro": "myPremiumTechPro",
  "homeshield-elite": "homeshieldElite",
  "yttv-basic": "yttvBasic",
  "unlimited-voice": "unlimitedVoice",
  "total-shield": "totalShield",
  "identity-protection": "identityProtection",
  "wifi-security-plus": "wifiSecurityPlus",
  "unbreakable-wifi": "unbreakableWifi",
  "netflix-bundle": "netflixBundle",
};

// INTERNET PRODUCTS
export const internetProducts = [
  FIBER_200,
  FIBER_500,
  FIBER_GIG,
  FIBER_2GIG,
  FIBER_5GIG,
  FIBER_7GIG,
];

// VAS PRODUCTS
export const vasProducts = [
  WIFI_SECURITY,
  WHOLE_HOME_WIFI,
  MY_PREMIUM_TECH_PRO,
  HOMESHIELD_ELITE,
  YTTV_BASIC,
  UNLIMITED_VOICE,
  TOTAL_SHIELD,
  IDENTITY_PROTECTION,
  WIFI_SECURITY_PLUS,
  UNBREAKABLE_WIFI,
  NETFLIX_BUNDLE,
];

export default productHashMap;
